import { render, staticRenderFns } from "./IteComment.vue?vue&type=template&id=c817546e&scoped=true&"
import script from "./IteComment.vue?vue&type=script&lang=js&"
export * from "./IteComment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c817546e",
  null
  
)

export default component.exports